const http = require('../lib/httpClient');
const { getCookie, getChannelId, getEcommId, getXCommerceValue } = require('../lib/browserData');
const { COOKIES, COMMERCE_HEADER } = require('../constants');

const userConsentError = {
  code: 'UPDATE_CONSENT_ERROR',
  message: 'Unable to update consent',
};

const endpoint = '/s/auth/v1/user/consent';

async function catalystUserConsent(consent, tenantId, catalystBaseUrl = '') {
  const sessionId = getCookie(COOKIES.SESSION.VALUE);
  if (!sessionId) {
    return {
      data: undefined,
      errors: [{ code: 'UPDATE_CONSENT_ERROR', message: 'Session not found' }],
    };
  }
  const result = await http.post(
    `${catalystBaseUrl}${endpoint}`,
    { consent },
    {
      headers: {
        'x-channel-id': getChannelId(),
        'x-ecomm-name': getEcommId(tenantId),
        authorization: sessionId,
        'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
      },
    },
  );

  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [userConsentError] };
  const { success, errors } = responseBody;

  if (errors) return { data: undefined, errors };
  if (!success) {
    return {
      data: undefined,
      errors: [{ code: 'UPDATE_CONSENT_ERROR', message: 'Unable to update consent' }],
    };
  }
  return { data: { success }, errors: [] };
}

module.exports = catalystUserConsent;
